import {useEffect} from 'react';
import {WidgetProps} from '@wix/yoshi-flow-editor';
import type {CheckoutBrand} from '@wix/ambassador-ecom-v1-ecommerce-settings/types';
import {
  MessageSource,
  MessageType,
  type DesignChangeMessage,
  type ReadyMessage,
} from '../../../domain/composer/messages';
import {CheckoutControllerProps} from '../../../types/checkoutApp.types';

export type AttachComposerListenerParams = {
  onBrandOverride: (brand?: CheckoutBrand) => void;
  win?: Window;
};

export function attachComposerListener({onBrandOverride, win}: AttachComposerListenerParams): () => void {
  const targetWindow = win ?? window;

  const handler = (event: MessageEvent): void => {
    const data = event.data as Partial<DesignChangeMessage>;
    if (data?.source !== MessageSource.Composer) {
      return;
    }
    if (data.type === MessageType.DesignChange) {
      onBrandOverride(data.payload?.brand);
    }
  };

  targetWindow.addEventListener('message', handler);

  const ready: ReadyMessage = {source: MessageSource.Viewer, type: MessageType.Ready};
  targetWindow.parent?.postMessage(ready, '*');

  return () => targetWindow.removeEventListener('message', handler);
}

export const useComposerListener = (controllerProps: WidgetProps<CheckoutControllerProps>): void => {
  const isBMPreview = controllerProps?.navigationStore?.isBMPreview ?? false;
  const onBrandOverride = controllerProps?.checkoutSettingsStore?.onBrandOverride;

  useEffect(() => {
    if (!isBMPreview || !onBrandOverride) {
      return;
    }
    return attachComposerListener({onBrandOverride});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBMPreview, !onBrandOverride]);
};
